import { Slot } from 'expo-router';

export default function UserManagementLayout(): React.ReactElement {
  return <Slot />;
}
